import { FirebaseError } from 'firebase/app';
import { AUTH_ERROR_MESSAGES, AUTH_ERROR_CODES } from '../constants';
import { z } from 'zod';

export function handleAuthError(error: unknown): Error {
  // Handle Firebase Auth errors
  if (error instanceof FirebaseError) {
    const message = AUTH_ERROR_MESSAGES[error.code as keyof typeof AUTH_ERROR_CODES] 
      || error.message 
      || AUTH_ERROR_MESSAGES.default;
    console.error('Firebase Auth Error:', error.code, message);
    return new Error(message);
  }

  // Handle Zod validation errors
  if (error instanceof z.ZodError) {
    const message = error.errors.map(e => e.message).join(', ');
    console.error('Validation Error:', message);
    return new Error(message);
  }

  // Handle other errors
  console.error('Auth Error:', error);
  return new Error(
    error instanceof Error ? error.message : AUTH_ERROR_MESSAGES.default
  );
}